import api from '@/libs/axiosInstance';
import { downloadAcknowledgmentStatusQueryKey } from '@/hooks/queries/use-download-acknowledgment-status-query';
import type { ApiResponse, MentionDownloadAcknowledgmentStatusDto } from '@fluenceur/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';

const acknowledgeSession = async (): Promise<MentionDownloadAcknowledgmentStatusDto> => {
  const response = await api.post<ApiResponse<MentionDownloadAcknowledgmentStatusDto>>(
    '/dashboard/mentions/download/acknowledge-session',
    { confirmed: true }
  );

  if (response.data.success && response.data.data) {
    return response.data.data;
  }

  throw new Error(response.data.message || 'Failed to record acknowledgment');
};

export const useAcknowledgeDownloadSession = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: acknowledgeSession,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: downloadAcknowledgmentStatusQueryKey });
    },
  });
};
